import type { Enrolment, EnrolmentNetwork, EnrolmentStatus } from '../../../types/alertEnrolment';

export const SINGLE_BRAND_PLATFORMS = ['stripe', 'paypal', 'shopify'] as const;

// {main,bg} mirroring the AlertCmStatusChip color approach.
export const STATUS_COLORS: Record<EnrolmentStatus, { main: string; bg: string }> = {
  not_submitted: { main: '#6b7280', bg: '#f1f2f4' },
  submitted: { main: '#b45309', bg: '#fff3da' },
  enrolled: { main: '#15803d', bg: '#e3f8ea' },
  transfer_pending: { main: '#1d4ed8', bg: '#e0ecfe' },
  transfer_in_progress: { main: '#7c3aed', bg: '#f3e8ff' },
};

export const STATUS_OPTIONS: { value: EnrolmentStatus; label: string }[] = [
  { value: 'not_submitted', label: 'Not Submitted' },
  { value: 'submitted', label: 'Submitted' },
  { value: 'enrolled', label: 'Enrolled' },
];

// Ethoca, CDRN, RDR and OI/CE also support the transfer lifecycle; other networks use the base set.
export const STATUS_OPTIONS_TRANSFER: { value: EnrolmentStatus; label: string }[] = [
  ...STATUS_OPTIONS,
  { value: 'transfer_in_progress', label: 'Transfer In Progress' },
  { value: 'transfer_pending', label: 'Transfer Pending' },
];

export const NETWORK_COLUMNS: { network: EnrolmentNetwork; label: string; field: keyof Enrolment; transferable?: boolean }[] = [
  { network: 'ethoca', label: 'Ethoca', field: 'ethocaStatus', transferable: true },
  { network: 'cdrn', label: 'CDRN', field: 'cdrnStatus', transferable: true },
  { network: 'rdr', label: 'RDR', field: 'rdrStatus', transferable: true },
  { network: 'oice', label: 'OI/CE', field: 'oiceStatus', transferable: true },
  { network: 'tc', label: 'TC40/TC15', field: 'tcStatus' },
  { network: 'discover', label: 'Discover', field: 'discoverStatus' },
  { network: 'amex', label: 'Amex', field: 'amexStatus' },
];
